import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { BodyMassIndexValue } from 'types/enums';
import { ValueOf } from 'types/types';

type FilterValue = ValueOf<typeof BodyMassIndexValue>;

const filterData: Record<FilterValue, (value: number) => boolean> = {
  [BodyMassIndexValue.LOW]: (value: number) => value < BodyMassIndexValue.LOW,
  [BodyMassIndexValue.MID]: (value: number) => value >= BodyMassIndexValue.LOW && value <= BodyMassIndexValue.MID,
  [BodyMassIndexValue.MID_HIGH]: (value: number) => value > BodyMassIndexValue.MID && value <= BodyMassIndexValue.HIGHT,
  [BodyMassIndexValue.HIGHT]: (value: number) => value > BodyMassIndexValue.HIGHT,
};

const getFilterParams = () => ({
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<unknown, number | string>) => {
      if (typeof params.value !== 'number') {
        return false;
      }

      return filterData[filterItem.operator as FilterValue](params.value * 100);
    };
  },
  InputComponentProps: { type: 'number' },
});

export const getPatientBodyMassFilters = (): GridFilterOperator[] => {
  const low = {
    label: `Less then ${BodyMassIndexValue.LOW}`,
    value: BodyMassIndexValue.LOW.toString(),
    ...getFilterParams(),
  };

  const lowMid = {
    label: `From ${BodyMassIndexValue.LOW} to ${BodyMassIndexValue.MID}`,
    value: BodyMassIndexValue.MID.toString(),
    ...getFilterParams(),
  };

  const midHigh = {
    label: `From ${BodyMassIndexValue.MID} to ${BodyMassIndexValue.HIGHT}`,
    value: BodyMassIndexValue.MID_HIGH,
    ...getFilterParams(),
  };

  const hight = {
    label: `More then ${BodyMassIndexValue.HIGHT}`,
    value: BodyMassIndexValue.HIGHT.toString(),
    ...getFilterParams(),
  };

  return [low, lowMid, midHigh, hight];
};
